module.exports = __webpack_public_path__ + "static/img/map.9712b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.jpg
// module id = sjKi
// module chunks = 0